"use client";

import { c as _c } from "react/compiler-runtime";
import MemesWaveZapIcon from "@/components/brain/left-sidebar/waves/MemesWaveZapIcon";
import { formatMemesQuickVoteLeftThisRoundText, formatMemesQuickVoteUnratedText } from "@/hooks/memesQuickVote.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import React from "react";
interface MemesWaveQuickVoteTriggerProps {
  readonly isAvailable?: boolean | undefined;
  readonly className?: string | undefined;
  readonly leftThisRoundCount: number;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
  readonly unratedCount: number;
}
const MemesWaveQuickVoteTrigger: React.FC<MemesWaveQuickVoteTriggerProps> = t0 => {
  const $ = _c(16);
  const {
    isAvailable: t1,
    className,
    leftThisRoundCount,
    onOpenQuickVote,
    onPrefetchQuickVote,
    unratedCount
  } = t0;
  const isAvailable = t1 === undefined ? true : t1;
  if (!isAvailable) {
    return null;
  }
  let t2;
  if ($[0] !== leftThisRoundCount || $[1] !== unratedCount) {
    t2 = leftThisRoundCount > 0 ? `${formatMemesQuickVoteLeftThisRoundText(leftThisRoundCount)}, ${formatMemesQuickVoteUnratedText(unratedCount)} in the memes wave` : "Quick vote";
    $[0] = leftThisRoundCount;
    $[1] = unratedCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const label = t2;
  let t3;
  if ($[3] !== leftThisRoundCount || $[4] !== unratedCount) {
    t3 = leftThisRoundCount > 0 ? `${formatMemesQuickVoteLeftThisRoundText(leftThisRoundCount)}, ${formatMemesQuickVoteUnratedText(unratedCount)}` : "Quick vote";
    $[3] = leftThisRoundCount;
    $[4] = unratedCount;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const title = t3;
  const t4 = `tw-flex tw-items-center tw-gap-x-1.5 tw-rounded-full tw-border tw-border-solid tw-border-primary-500/30 tw-bg-primary-500/10 tw-px-2.5 tw-py-2 tw-text-primary-300 tw-shadow-[0_12px_24px_rgba(11,93,255,0.2)] tw-transition-colors tw-duration-300 desktop-hover:hover:tw-border-primary-400/40 desktop-hover:hover:tw-bg-primary-500/15 ${className ?? ""}`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MemesWaveZapIcon className="tw-size-4 tw-flex-shrink-0 tw-fill-primary-300/20" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== leftThisRoundCount) {
    t6 = leftThisRoundCount > 0 && <span className="tw-text-xs tw-font-semibold">{formatNumberWithCommas(leftThisRoundCount)}</span>;
    $[7] = leftThisRoundCount;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== label || $[10] !== onOpenQuickVote || $[11] !== onPrefetchQuickVote || $[12] !== t4 || $[13] !== t6 || $[14] !== title) {
    t7 = <button type="button" aria-label={label} title={title} onClick={onOpenQuickVote} onFocus={onPrefetchQuickVote} onMouseEnter={onPrefetchQuickVote} className={t4}>{t5}{t6}</button>;
    $[9] = label;
    $[10] = onOpenQuickVote;
    $[11] = onPrefetchQuickVote;
    $[12] = t4;
    $[13] = t6;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default MemesWaveQuickVoteTrigger;